function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 自定义埋点,以后要在一个需求里加自定义业务埋点就在这新建一个吧
import { logger } from './logger';
export var creativeCategory = 'kwai-log-creative';
var isInApp = 'inside';
var isOutApp = 'outside';
export var LogTypeEnum;

(function (LogTypeEnum) {
  LogTypeEnum["CUSTOM"] = "custom";
  LogTypeEnum["PV"] = "pv";
  LogTypeEnum["SHOW"] = "show";
  LogTypeEnum["CLICK"] = "click";
  LogTypeEnum["API_ERROR"] = "api_error";
})(LogTypeEnum || (LogTypeEnum = {})); // 业务核心埋点


export var sendLiveCustomLog = function sendLiveCustomLog(options) {
  var data = _objectSpread(_objectSpread({}, options), {}, {
    event_type: typeof options.event_type === 'undefined' ? LogTypeEnum.CUSTOM : options.event_type,
    result_type: typeof options.result_type === 'undefined' ? '' : "".concat(options.result_type),
    category: 'kwai-creator-log'
  });

  logger.kwailog.sendRadarLog(data);
}; // 数据中心

export var sendDataCustomLog = function sendDataCustomLog(_ref) {
  var event = _ref.event;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "data-".concat(event)
  });
}; // 周报

export var sendWeeklyCustomLog = function sendWeeklyCustomLog(_ref2) {
  var event = _ref2.event,
      src = _ref2.src;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "weekly-".concat(event),
    src: src
  });
}; // 裂变

export var sendFissionCustomLog = function sendFissionCustomLog(_ref3) {
  var event = _ref3.event,
      src = _ref3.src;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "fission-".concat(event),
    src: src
  });
}; // 榜单

export var sendRankingCustomLog = function sendRankingCustomLog(_ref4) {
  var event = _ref4.event,
      src = _ref4.src;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "ranking-".concat(event),
    src: src
  });
}; // 任务

export var sendTaskCustomLog = function sendTaskCustomLog(_ref5) {
  var event = _ref5.event,
      src = _ref5.src;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "task-".concat(event),
    src: src
  });
};
export var sendFundCustomLog = function sendFundCustomLog(_ref6) {
  var event = _ref6.event,
      src = _ref6.src;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "fund-".concat(event),
    src: src
  });
};
export var sendBadgeLog = function sendBadgeLog(_ref7) {
  var event = _ref7.event,
      src = _ref7.src;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "badge-".concat(event),
    src: src
  });
}; // 印尼打卡页面

export var sendClockCustomLog = function sendClockCustomLog(_ref8) {
  var event = _ref8.event,
      src = _ref8.src;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "clock-".concat(event),
    src: src
  });
}; // eoy

export var sendEoyCustomLog = function sendEoyCustomLog(_ref9) {
  var event = _ref9.event;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "eoy-".concat(event)
  });
}; // spa页面的pv

export var sendSpaPv = function sendSpaPv() {
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: 'spa-pv',
    src: window.location.pathname
  });
}; // 更新页面异常

export var sendUpgradeErrorPv = function sendUpgradeErrorPv(data) {
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: 'upgrade-error',
    result_type: 'error',
    src: window.location.pathname,
    extra_info: JSON.stringify(data)
  });
}; // top100页面

export var sendTop100CustomLog = function sendTop100CustomLog(_ref10) {
  var event = _ref10.event;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "clock-".concat(event)
  });
}; // 黑人活动页面

export var sendBlackMonthCustomLog = function sendBlackMonthCustomLog(_ref11) {
  var event = _ref11.event,
      src = _ref11.src;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "black-".concat(event),
    src: "venue_".concat(src)
  });
};
export var sendShareCustomLog = function sendShareCustomLog(_ref12) {
  var event = _ref12.event,
      extra_info = _ref12.extra_info;
  logger.kwailog.sendRadarLog({
    category: creativeCategory,
    name: "share-".concat(event),
    src: window.location.href,
    extra_info: extra_info
  });
};